import classnames from 'classnames';
import type { SearchFilterField, SearchParameters } from 'lib-search-types';
import { isLeafFilterCondition } from 'lib-search-ui';
import isEmpty from 'lodash/isEmpty';

import { convertSortObjectToString } from '../../../utils/sort/convertSort';
import { sortOptions } from '../../results/components/sort/searchResultsSort';

import { SavedSearchFiltersCondition } from './components/condition/savedSearchFiltersCondition';
import { SavedSearchFiltersItem } from './components/item/savedSearchFiltersItem';
import styles from './savedSearchFilters.module.scss';

export type SavedSearchFiltersProps = {
  variant: 'text' | 'chips';
  params: SearchParameters<'conversations'>;
  onRemove?: (
    field: 'query' | SearchFilterField<'conversations'>,
    index: number,
  ) => void;
};

export const SavedSearchFilters = ({
  variant,
  params: { query, filters, isStrict, sortBy },
  onRemove,
}: SavedSearchFiltersProps): JSX.Element => {
  const rootClass = classnames(styles.filters, {
    [styles.filtersText]: variant === 'text',
    [styles.filtersChips]: variant === 'chips',
  });

  return (
    <div className={rootClass}>
      {query && (
        <>
          <SavedSearchFiltersItem
            variant={variant}
            label="Keyword"
            value={query}
            onDelete={
              isEmpty(filters?.filters)
                ? undefined
                : () => onRemove?.('query', -1)
            }
          />

          <SavedSearchFiltersItem
            variant={variant}
            label="Exact match"
            value={isStrict ? 'Enabled' : 'Disabled'}
          />
        </>
      )}

      <SavedSearchFiltersItem
        variant={variant}
        label="Sort by"
        value={
          (sortBy &&
            sortOptions.find(
              ({ value }) => value === convertSortObjectToString(sortBy),
            )?.label) ||
          'Relevance'
        }
      />

      {filters?.filters
        .filter(isLeafFilterCondition)
        .map((condition, index) => (
          <SavedSearchFiltersCondition
            key={`${condition.field}-${index}`}
            variant={variant}
            condition={condition}
            onDelete={() => onRemove?.(condition.field, index)}
          />
        ))}
    </div>
  );
};
